// This icon file is generated automatically.
var PCaretDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.13 3.69H.87c-.3 0-.48.32-.29.54l5.13 5.95a.4.4 0 00.58 0l5.13-5.95c.2-.22.02-.54-.29-.54z", "fill-rule": "nonzero" } }] }, "name": "p-caret-down", "theme": "outlined" };
export default PCaretDownOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCaretDownOutlined.js
// module id = 3264
// module chunks = 0